// maths-portll — per-skill mastery writer. The DNF embed (window.MathsGame) streams each completed
// visit here; we persist it to the parent-owned family plane. Non-PII only (no child real name).
import { doc, setDoc, getDocs, collection } from "firebase/firestore";
import { db } from "./firebase.js";

export function setMastery(uid, childId, skillId, record) {
  const rec = { ...record };
  // Coalesce the contract-required keys so the doc always carries {pKnown, attempts, state}
  // (rule gate is size() <= 24; these defaults never add net keys the caller didn't intend).
  if (typeof rec.pKnown !== "number") rec.pKnown = 0;
  if (typeof rec.attempts !== "number") rec.attempts = 0;
  if (typeof rec.state !== "string") rec.state = "not-tested";
  return setDoc(doc(db, `users/${uid}/children/${childId}/mastery/${skillId}`), rec, { merge: true });
}

// Read the child's whole mastery plane (skillId -> record) so the engine can seed its local BKT on
// load — progress + difficulty survive across devices/sessions. Best-effort; {} on any failure.
export async function getMastery(uid, childId) {
  if (!uid || !childId) return {};
  try {
    const snap = await getDocs(collection(db, `users/${uid}/children/${childId}/mastery`));
    const out = {};
    snap.forEach((d) => { out[d.id] = d.data(); });
    return out;
  } catch (e) {
    return {};
  }
}
